import { dareEndpointIds } from 'root/src/shared/dares/dares.constants';
export const completeDareEndpoint = {
    [dareEndpointIds.COMPLETE_DARE]: {
        isInternal: true,
        payloadSchema: {
            type: 'object',
            properties: {
                dareId: {
                    type: 'string',
                },
            },
            required: ['dareId'],
        },
    },
};
